import api from '../api'

const baseUrl = '/BizSchool/api/Admin'

const dadbanCourseSessionProvider = {
  getAllCourseSessions(params) {
    return api.get(`${baseUrl}/GetCourseSession/${params}`)
  },

  getCourseSession(id) {
    return api.get(`${baseUrl}/GetCourseSession/${id}`)
  },

  addCourseSession(params) {
    return api.post(`${baseUrl}/CourseSession`, params)
  },

  addCourseSessionFile(params) {
    return api.post(`${baseUrl}/CourseSessionFile`, params)
  },

  updateCourseSessionFile(params) {
    return api.put(`${baseUrl}/CourseSessionFile`, params)
  },

  deleteCourseSessionFile(params = {}) {
    return api.delete(`${baseUrl}/CourseSessionFile/${params}`)
  },

  updateCourseSession(params = {}) {
    return api.put(`${baseUrl}/CourseSession`, params)
  },

  deleteCourseSession(params = {}) {
    return api.delete(`${baseUrl}/CourseSession/${params}`)
  },

  generateToken() {
    return api.get('/BizSchool/api/Home/Token')
  },
}

export default dadbanCourseSessionProvider
